/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dropdown.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/dropdown/dropdown.component';
import * as i3 from '../../../../app/shared/browser-events.service';
import * as i4 from '../../../../app/shared/dropdown/dropdown.service';
const styles_DropdownComponent:any[] = [i0.styles];
export const RenderType_DropdownComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_DropdownComponent,data:{}});
export function View_DropdownComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_DropdownComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'dropdown',([] as any[]),
      (null as any),(null as any),(null as any),View_DropdownComponent_0,RenderType_DropdownComponent)),
      i1.ɵdid(1228800,(null as any),5,i2.DropdownComponent,[i1.ElementRef,i1.Renderer2,
          i3.BrowserEvents,i4.DropdownService],(null as any),(null as any)),i1.ɵqud(335544320,
          1,{trigger:0}),i1.ɵqud(335544320,2,{menu:0}),i1.ɵqud(335544320,3,{origin:0}),
      i1.ɵqud(603979776,4,{menuItems:1}),i1.ɵqud(335544320,5,{input:0})],(null as any),
      (null as any));
}
export const DropdownComponentNgFactory:i1.ComponentFactory<i2.DropdownComponent> = i1.ɵccf('dropdown',
    i2.DropdownComponent,View_DropdownComponent_Host_0,{trigger:'trigger',origin:'origin',
        direction:'direction',autoPosition:'autoPosition',disableTrigger:'disableTrigger',
        closeOnTriggerClick:'closeOnTriggerClick'},{onFirstOpen:'onFirstOpen',onClose:'onClose'},
    ['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvZHJvcGRvd24vZHJvcGRvd24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2Ryb3Bkb3duL2Ryb3Bkb3duLmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L3dhbXA2NC93d3cvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2Ryb3Bkb3duL2Ryb3Bkb3duLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvZHJvcGRvd24vZHJvcGRvd24uY29tcG9uZW50LnRzLkRyb3Bkb3duQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PiIsIjxkcm9wZG93bj48L2Ryb3Bkb3duPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OzJCQ0FBOzs7b0JDQUE7TUFBQTthQUFBOzZDQUFBO1VBQUE7YUFBQTs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/dropdown/dropdown.component.ngfactory.ts